// import IconButton from "../../controls/IconButton";
// import Icon from "../../../assets/icons/Icon";
// import Loading from "../../controls/Loading";
// import CustomTable from "../../controls/CustomTable";
// import { deleteCustomer, fetchCustomerAudittrails, getCustomerDashboardHeaders, getCustomerDetails, getCustomerEasyRewardzLoyaltyPoints, getCustomerLoyaltyPoints, getCustomerMLoyalLoyaltyPoints, getCustomerPackages, getCustomerProducts, getCustomerTransactions, getEasyRewardWorkflowWidget, getLoyaltyLedgersByCustomerID, getPastAppointmentsForCustomer, getUpcomingAppointmentsForCustomer, getWalletLedgersByCustomerID } from "../../../api/CustomerApi";
// import { useSelector } from "react-redux";
// import { selectCustomerModule } from "../../../redux/slices/customFieldSlice";
// import { useState, useEffect } from "react";
// import ViewPage from "../../controls/ViewPage";
// import Tab from "../../controls/Tab";
// import ConfirmBox from "../../controls/ConfirmBox";
// import useCurrencySymbol from "../../controls/CurrencySymbol";
// import { toast } from "react-toastify";
// import DetailTable from "../../controls/DetailTable";
// import DetailRow from "../../controls/DetailRow";
// import AuditTrail from "../../controls/AuditTrail";
// import axios from "axios";
// import { registerVersion } from "firebase/app";
// import { selectRegistration } from "../../../redux/slices/userSlice";
// import { hasValue, useAcl } from "../../controls/CommonFunctions";
// import Button from "../../controls/Button";
// const CustomerDetail = ({ customerData, handleCancelClick, handleEditClick, handleOnDelete }) => {
//       const { getVisibility } = useAcl();
//   const [activeTab, setActiveTab] = useState("Overview");
//   const [apiData, setApiData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [transactionActiveTab, setTransactionActiveTab] = useState("Sales");
//   const currencySymbol = useCurrencySymbol();
//   const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
//   const [isHovering, setIsHovering] = useState(false);
//   const [viewTransaction, setViewTransaction] = useState(false);
//   const [auditTrails, setAuditTrails] = useState([]);
//   const [AuditTrailLoading, setAuditTrailLoading] = useState(false);
//   const registration=useSelector(selectRegistration);
//   const store = useSelector((state) => state.store.store);
//   console.log("registration",registration);
//   // Customer Ledger States
//   const [customerLedgerData, setCustomerLedgerData] = useState([]);
//   const [ledgerLoading, setLedgerLoading] = useState(false);
//   const [fromDate, setFromDate] = useState(new Date());
//   const [toDate, setToDate] = useState(null);
//   const [loyalty,setLoyalty]=useState({});

//   const customerCustomFieldData = useSelector(selectCustomerModule);

//   const fetchCustomerLoyalty=async()=>{
//     try{
//       const response=await    getCustomerLoyaltyPoints(customerData?.key);
//       if(response?.code=="0"){
//       setLoyalty(response?.LoyaltyCustomer);
//       }
//       else{
//       toast.error(response?.message || "Failed to fetch loyalty");
//       setLoyalty({});
//       }
//     }
//     catch(error){
//      toast.error("Failed to fetch loyalty");
//        setLoyalty({});
//     }
//   }

//   const fetchAllApis = async (customerID) => {
//     setLoading(true);
//     try {
//       const [
//         dashboardHeaders,
//         transactions,
//         products,
//         walletLedgers,
//         packages,
//         loyaltyLedgers,
//         upcomingAppointments,
//         pastAppointments,
//       ] = await Promise.all([
//         getCustomerDashboardHeaders(customerID),
//         getCustomerTransactions(customerID),
//         getCustomerProducts(customerID),
//         getWalletLedgersByCustomerID(0,20,customerID),
//         getCustomerPackages(customerID),
//         getLoyaltyLedgersByCustomerID(customerID),
//         getUpcomingAppointmentsForCustomer(customerID),
//         getPastAppointmentsForCustomer(customerID),
     
//       ].map(p => p.catch(error => {
//         console.error('Error in API call:', error);
//         return null;
//       })));

//       setApiData({
//         dashboardHeaders,
//         transactions,
//         products,
//         walletLedgers,
//         packages,
//         loyaltyLedgers,
//         upcomingAppointments,
//         pastAppointments,
//       });
//     } catch (error) {
//       console.error('Unexpected error in Promise.all:', error);
//       toast.error("Failed to load customer data");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchAuditTrailsData = async (key) => {
//     setAuditTrailLoading(true);
//     try {
//       const response = await fetchCustomerAudittrails(key);
//       setAuditTrails(response.data);
//     } catch (error) {
//       console.log("error", error);
//       toast.error("Failed to load data !");
//     } finally {
//       setAuditTrailLoading(false);
//     }
//   };

//   // Fetch Customer Ledger Data
//   const fetchCustomerLedger = async (customerId, fromDate, toDate) => {
//     setLedgerLoading(true);
//     try {
//       const requestBody = {
//         customerId: customerId,
//       };

//       // Add dates only if they exist
//       if (fromDate) {
//         requestBody.fromDate = fromDate.getTime().toString();
//       }
//       if (toDate) {
//         requestBody.toDate = toDate.getTime().toString();
//       }

//       const response = await axios.post(
//         "https://pincodebackgroundprocess-2qevtrwogq-el.a.run.app/report/customer/ledger",
//         requestBody,
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       console.log("response", response);

//       const data = response.data?.reportData || [];
//       setCustomerLedgerData(data);

//     } catch (error) {
//       console.error("Error fetching customer ledger:", error);
//       toast.error("Failed to load customer ledger data");
//     } finally {
//       setLedgerLoading(false);
//     }
//   };

//   const roundUpTo2 = (num) => {
//     return Math.round(Number(num) * 100) / 100;
//   }

//   const initialization=async()=>{
//        if(registration?.LoyaltyEnabled){
//  fetchCustomerLoyalty();
//       }
//        if(registration?.EnableMLoyal){
//                const response=await getCustomerMLoyalLoyaltyPoints(registration?.key, 
//                       store.key, 
//                         customerData?.key, 
//                         customerData?.PhoneNo);


//                          setLoyalty({
//                                 LoyaltyType:response.CUSTOMER_DETAILS[0].Slab + " (Pt: " + response.CUSTOMER_DETAILS[0].LoyalityPoints + ", Vl: " + response.CUSTOMER_DETAILS[0].LoyalityPointsValue + ")",
//                                 LoyaltyPoints:response.CUSTOMER_DETAILS[0].LoyalityPoints
//                             });

//                 }

//                   if(registration?.EnableEasyRewardz){
//                const response=await getCustomerEasyRewardzLoyaltyPoints(registration.key, 
//                         store.key, 
//                         store.StoreCode, 
//                         customerData?.key, 
//                         customerData?.PhoneNo);


//                          setLoyalty({
//                                 LoyaltyType:"Loyalty",
//                                     LoyaltyPoints:response.Data.AvailablePoints
//                             });

//                 }
//   }
//   useEffect(() => {
//     if (customerData?.key) {
//      initialization();
     
//       fetchAllApis(customerData.key);
//       fetchAuditTrailsData(customerData.key);
//       // Fetch ledger data on initial load
//       fetchCustomerLedger(customerData.key, null, null);
//     }
//   }, [customerData?.key]);

//   // Handle Date Filter Change for Ledger
//   const handleLedgerFilter = () => {
//     if (customerData?.key) {
//       fetchCustomerLedger(customerData.key, fromDate, toDate);
//     }
//   };

//   // Reset Date Filter
//   const handleResetFilter = () => {
//     setFromDate(null);
//     setToDate(null);
//     if (customerData?.key) {
//       fetchCustomerLedger(customerData.key, null, null);
//     }
//   };

//   // Download CSV
//   const downloadCSV = () => {
//     if (customerLedgerData.length === 0) {
//       toast.warning("No data to download");
//       return;
//     }

//     const headers = ["Transaction No", "Transaction Type", "Customer Name", "Debit", "Credit", "Balance", "Narration"];

//     const csvRows = customerLedgerData.map(item => [
//       `"${item.transactionNo || ''}"`,
//       `"${item.transactionType || ''}"`,
//       `"${item.customerName || ''}"`,
//       item.debit || '0',
//       item.credit || '0',
//       item.Balance || '0',
//       `"${item.Narration || ''}"`
//     ]);

//     const csvContent = [
//       headers.join(','),
//       ...csvRows.map(row => row.join(','))
//     ].join('\n');

//     const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//     const url = window.URL.createObjectURL(blob);
//     const a = document.createElement('a');
//     a.href = url;
//     a.download = `customer_ledger_${customerData?.FirstName || 'customer'}_${new Date().toISOString().split('T')[0]}.csv`;
//     document.body.appendChild(a);
//     a.click();
//     document.body.removeChild(a);
//     window.URL.revokeObjectURL(url);

//     toast.success("CSV download started");
//   };

//   // Download PDF (Placeholder - you need to implement actual PDF generation)
//   // const downloadPDF = () => {
//   //   if (customerLedgerData.length === 0) {
//   //     toast.warning("No data to download");
//   //     return;
//   //   }

//   //   toast.info("PDF download functionality coming soon");
//   // };

//   const downloadPDF = () => {
//     if (customerLedgerData.length === 0) {
//       toast.warning("No data to download");
//       return;
//     }

//     try {
//       // Calculate totals
//       const totalDebit = customerLedgerData.reduce((sum, item) => sum + (item.debit || 0), 0);
//       const totalCredit = customerLedgerData.reduce((sum, item) => sum + (item.credit || 0), 0);
//       const netBalance = totalDebit - totalCredit;

//       // Create a new window for printing
//       const printWindow = window.open('', '_blank');

//       const htmlContent = `
//       <!DOCTYPE html>
//       <html>
//       <head>
//         <title>Customer Ledger - ${customerData?.FirstName || ''} ${customerData?.LastName || ''}</title>
//         <style>
//           @media print {
//             @page {
//               size: landscape;
//               margin: 10mm;
//             }
            
//             body {
//               font-family: Arial, sans-serif;
//               margin: 0;
//               padding: 20px;
//             }
            
//             .header {
//               text-align: center;
//               margin-bottom: 20px;
//               padding-bottom: 10px;
//               border-bottom: 2px solid #3498db;
//             }
            
//             .header h1 {
//               color: #2c3e50;
//               margin: 0;
//               font-size: 24px;
//             }
            
//             .header h3 {
//               color: #7f8c8d;
//               margin: 5px 0 0 0;
//               font-size: 16px;
//             }
            
//             .meta-info {
//               display: flex;
//               justify-content: space-between;
//               margin-bottom: 20px;
//               font-size: 12px;
//               color: #666;
//             }
            
//             table {
//               width: 100%;
//               border-collapse: collapse;
//               margin-bottom: 20px;
//               font-size: 11px;
//             }
            
//             th {
//               background-color: #3498db;
//               color: white;
//               font-weight: bold;
//               padding: 8px;
//               text-align: left;
//               border: 1px solid #ddd;
//             }
            
//             td {
//               padding: 8px;
//               border: 1px solid #ddd;
//             }
            
//             tr:nth-child(even) {
//               background-color: #f9f9f9;
//             }
            
//             .debit {
//               text-align: right;
//               color: #e74c3c;
//               font-weight: bold;
//             }
            
//             .credit {
//               text-align: right;
//               color: #27ae60;
//               font-weight: bold;
//             }
            
//             .balance {
//               text-align: right;
//               font-weight: bold;
//             }
            
//             .summary {
//               margin-top: 30px;
//               padding-top: 20px;
//               border-top: 2px solid #3498db;
//             }
            
//             .summary-grid {
//               display: flex;
//               gap: 20px;
//               margin-top: 10px;
//             }
            
//             .summary-card {
//               padding: 15px;
//               border-radius: 5px;
//               min-width: 180px;
//             }
            
//             .debit-card {
//               background-color: #f8d7da;
//               border: 1px solid #f5c6cb;
//             }
            
//             .credit-card {
//               background-color: #d4edda;
//               border: 1px solid #c3e6cb;
//             }
            
//             .balance-card {
//               background-color: ${netBalance < 0 ? '#f8d7da' : netBalance > 0 ? '#d4edda' : '#e2e3e5'};
//               border: 1px solid ${netBalance < 0 ? '#f5c6cb' : netBalance > 0 ? '#c3e6cb' : '#d6d8d9'};
//             }
            
//             .footer {
//               margin-top: 30px;
//               text-align: center;
//               font-size: 10px;
//               color: #666;
//               border-top: 1px solid #eee;
//               padding-top: 10px;
//             }
//           }
          
//           @media screen {
//             body {
//               font-family: Arial, sans-serif;
//               margin: 20px;
//               padding: 20px;
//               background-color: #f5f5f5;
//             }
            
//             .print-container {
//               max-width: 1200px;
//               margin: 0 auto;
//               background: white;
//               padding: 30px;
//               box-shadow: 0 0 10px rgba(0,0,0,0.1);
//             }
//           }
//         </style>
//       </head>
//       <body>
//         <div class="print-container">
//           <div class="header">
//             <h1>Customer Ledger Report</h1>
//             <h3>${customerData?.FirstName || ''} ${customerData?.LastName || ''}</h3>
//           </div>
          
//           <div class="meta-info">
//             <div>
//               <strong>Generated on:</strong> ${new Date().toLocaleDateString('en-US', {
//         year: 'numeric',
//         month: 'short',
//         day: 'numeric',
//         hour: '2-digit',
//         minute: '2-digit'
//       })}
//             </div>
//             ${fromDate ? `
//             <div>
//               <strong>From Date:</strong> ${fromDate.toLocaleDateString('en-US', {
//         year: 'numeric',
//         month: 'short',
//         day: 'numeric'
//       })}
//             </div>
//             ` : ''}
//             <div>
//               <strong>Total Records:</strong> ${customerLedgerData.length}
//             </div>
//           </div>
          
//           <table>
//             <thead>
//               <tr>
//                 <th>#</th>
//                 <th>Transaction No</th>
//                 <th>Transaction Type</th>
//                 <th>Customer Name</th>
//                 <th>Debit</th>
//                 <th>Credit</th>
//                 <th>Balance</th>
//                 <th>Narration</th>
//               </tr>
//             </thead>
//             <tbody>
//               ${customerLedgerData.map((item, index) => `
//                 <tr>
//                   <td>${index + 1}</td>
//                   <td>${item.transactionNo || 'N/A'}</td>
//                   <td>${item.transactionType || 'N/A'}</td>
//                   <td>${item.customerName || 'N/A'}</td>
//                   <td class="debit">${currencySymbol} ${roundUpTo2(item.debit || 0)}</td>
//                   <td class="credit">${currencySymbol} ${roundUpTo2(item.credit || 0)}</td>
//                   <td class="balance" style="color: ${item.Balance < 0 ? '#e74c3c' : item.Balance > 0 ? '#27ae60' : '#2c3e50'}">
//                     ${currencySymbol} ${roundUpTo2(item.Balance || 0)}
//                   </td>
//                   <td>${item.Narration || 'No narration'}</td>
//                 </tr>
//               `).join('')}
//             </tbody>
//           </table>
          
//           <div class="summary">
//             <h3>Summary</h3>
//             <div class="summary-grid">
//               <div class="summary-card debit-card">
//                 <div><strong>Total Debit</strong></div>
//                 <div style="font-size: 18px; color: #721c24; margin-top: 5px;">
//                   ${currencySymbol} ${roundUpTo2(totalDebit)}
//                 </div>
//               </div>
              
//               <div class="summary-card credit-card">
//                 <div><strong>Total Credit</strong></div>
//                 <div style="font-size: 18px; color: #155724; margin-top: 5px;">
//                   ${currencySymbol} ${roundUpTo2(totalCredit)}
//                 </div>
//               </div>
              
//               <div class="summary-card balance-card">
//                 <div><strong>Net Balance</strong></div>
//                 <div style="font-size: 18px; color: ${netBalance < 0 ? '#721c24' : netBalance > 0 ? '#155724' : '#383d41'}; margin-top: 5px;">
//                   ${currencySymbol} ${roundUpTo2(netBalance)}
//                 </div>
//               </div>
//             </div>
//           </div>
          
//           <div class="footer">
//             <p>This is an auto-generated report. For any queries, please contact support.</p>
//           </div>
//         </div>
        
//         <script>
//           // Auto print and close
//           window.onload = function() {
//             setTimeout(function() {
//               window.print();
//               setTimeout(function() {
//                 window.close();
//               }, 1000);
//             }, 500);
//           };
//         </script>
//       </body>
//       </html>
//     `;

//       printWindow.document.write(htmlContent);
//       printWindow.document.close();

//       toast.success("Opening PDF print dialog...");

//     } catch (error) {
//       console.error("Error generating PDF:", error);
//       toast.error("Failed to generate PDF");
//     }
//   };

//   // Format data for tables
//   const topFiveProductsRows = apiData?.products?.searchResult
//     ?.map(product => ({
//       ...product,
//       total_quantity: parseFloat(product.total_quantity)
//     }))
//     ?.sort((a, b) => b.total_quantity - a.total_quantity)
//     ?.slice(0, 5)
//     ?.map((product, index) => ({
//       id: index,
//       productName: product.name,
//       totalQty: product.total_quantity.toString(),
//       totalSales: `${currencySymbol} ${roundUpTo2(product.total_sales)}`,
//       productType: product.product_type
//     })) || [];

//   const productRows = apiData?.products?.searchResult
//     ?.filter(product => product.product_type === "Goods for sale")
//     ?.map((product, index) => ({
//       id: index,
//       productName: product.name,
//       totalQty: product.total_quantity,
//       totalSales: `${currencySymbol} ${roundUpTo2(product.total_sales)}`
//     })) || [];

//   const serviceRows = apiData?.products?.searchResult
//     ?.filter(product => product.product_type === "Services")
//     ?.map((product, index) => ({
//       id: index,
//       productName: product.name,
//       totalSales: `${currencySymbol} ${roundUpTo2(product.total_sales)}`
//     })) || [];

//   const walletRows = apiData?.walletLedgers?.searchResult?.map((ledger, index) => ({
//     id: index,
//     date:ledger?.TransactionDate,
//     narration: ledger.Narration,
//     credit: ledger.Credit,
//     debit: ledger.Debit,
//     balance:ledger.Balance
//   })) || [];

//   const packageRows = apiData?.packages?.searchResult?.map((data, index) => ({
//     id: index,
//     transactionNo: data.TransactionNo,
//     packageName: data.PackageName,
//     packageStartDate: data.formattedStartDate,
//     packageEndDate: data.formattedEndDate,
//     packageStatus: data.PackageStatus,
//   })) || [];

//   const transactionRows = apiData?.transactions?.searchResult?.flatMap(transaction =>
//     transaction.LineItems?.map((item, index) => ({
//       id: `${transaction.key}-${index}`,
//       transactionNo: transaction.TransactionNo,
//       date: new Date(transaction.TransactionDate._seconds * 1000).toLocaleDateString(),
//       product: item.Product?.Name,
//       qty: item.Qty,
//       retailPrice: `${currencySymbol} ${roundUpTo2(item.RetailPrice)}`,
//       discount: item?.DiscountAmount ? `${currencySymbol} ${roundUpTo2(item?.DiscountAmount)}` : '-',
//       discountPercentage: item?.DiscountPer,
//       amount: `${currencySymbol} ${item.Amount}`
//     })) || []
//   ) || [];

//   const loyaltyRows = apiData?.loyaltyLedgers?.searchResult?.map((ledger, index) => ({
//     id: index,
//     date: new Date(ledger.TransactionDate._seconds * 1000).toLocaleDateString(),
//     narration: ledger.TransactionNo,
//     earn: ledger.Type === 'earn' ? ledger.LoyaltyPoints : '',
//     burn: ledger.Type === 'burn' ? ledger.LoyaltyPoints : '',
//   })) || [];

//   // Table columns
//   const productColumns = [
//     { field: "productName", headerName: "Product Name" },
//     { field: "totalQty", headerName: "Total Qty", align: "right" },
//     { field: "totalSales", headerName: "Total Sales", align: "right" },
//   ];

//   const serviceColumns = [
//     { field: "productName", headerName: "Service Name" },
//     { field: "totalSales", headerName: "Total Sales", align: "right" },
//   ];

//   const walletColumns = [
//     { field: "date", headerName: "Date" },
//     {
//       field: "narration",
//       headerName: "Narration",
//     },
//     { field: "credit", headerName: "Credit",type:"currency" },
//     { field: "debit", headerName: "Debit", type:"currency" },
//     { field: "balance", headerName: "Balance", type:"currency"},
//   ];

//   const packageColumns = [
//     { field: "transactionNo", headerName: "Transaction No" },
//     { field: "packageName", headerName: "Package Name" },
//     { field: "packageStartDate", headerName: "Start Date" },
//     { field: "packageEndDate", headerName: "End Date" },
//     { field: "packageStatus", headerName: "Status" },
//   ];

//   const transactionColumns = [
//     { field: "transactionNo", headerName: "Transaction No" },
//     { field: "date", headerName: "Date" },
//     {
//       field: "",
//       headerName: "Product",
//       renderCell: ({ row }) => (
//         <div className="text-wrap text-[14px] max-w-[100px]">{row.product}</div>
//       ),
//     },
//     { field: "qty", headerName: "Qty", align: "right" },
//     { field: "retailPrice", headerName: "Retail Price", align: "right" },
//     { field: "discount", headerName: "Discount", align: "right" },
//     { field: "amount", headerName: "Amount", align: "right" },
//   ];

//   const loyaltyColumns = [
//     { field: "date", headerName: "Date" },
//     {
//       field: "",
//       headerName: "Narration",
//       renderCell: ({ row }) => (
//         <div className="whitespace-nowrap">
//           {row?.earn == "" ? "Burn" : "Earn"} for transaction: {row?.narration}
//         </div>
//       ),
//     },
//     { field: "earn", headerName: "Earn", align: "right" },
//     { field: "burn", headerName: "Burn", align: "right" },
//   ];

//   // Customer Ledger Columns
//   const ledgerColumns = [
//     {
//       field: "transactionNo",
//       headerName: "Transaction No",
//       renderCell: ({ row }) => (
//         <div className="font-medium text-blue-600 hover:text-blue-800 cursor-pointer">
//           {row.transactionNo}
//         </div>
//       )
//     },
//     {
//       field: "transactionType",
//       headerName: "Transaction Type",
//       renderCell: ({ row }) => (
//         <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
//           {row.transactionType}
//         </span>
//       )
//     },
//     {
//       field: "customerName",
//       headerName: "Customer Name",
//       renderCell: ({ row }) => (
//         <div className="font-medium">{row.customerName}</div>
//       )
//     },
//     {
//       field: "debit",
//       headerName: "Debit",
//       align: "right",
//       renderCell: ({ row }) => (
//         <div className={`font-semibold ${row.debit > 0 ? 'text-red-600' : 'text-gray-400'}`}>
//           {currencySymbol} {roundUpTo2(row.debit)}
//         </div>
//       )
//     },
//     {
//       field: "credit",
//       headerName: "Credit",
//       align: "right",
//       renderCell: ({ row }) => (
//         <div className={`font-semibold ${row.credit > 0 ? 'text-green-600' : 'text-gray-400'}`}>
//           {currencySymbol} {roundUpTo2(row.credit)}
//         </div>
//       )
//     },
//     {
//       field: "Balance",
//       headerName: "Balance",
//       align: "right",
//       renderCell: ({ row }) => (
//         <div className={`font-bold ${row.Balance < 0 ? 'text-red-600' : row.Balance > 0 ? 'text-green-600' : 'text-gray-700'}`}>
//           {currencySymbol} {roundUpTo2(row.Balance)}
//         </div>
//       )
//     },
//     {
//       field: "Narration",
//       headerName: "Narration",
//       renderCell: ({ row }) => (
//         <div className="text-sm text-gray-600 max-w-[200px] truncate" title={row.Narration}>
//           {row.Narration}
//         </div>
//       )
//     }
//   ];

//   const tabs = [
//     { name: "Overview", label: "Overview" },
//     { name: "Transaction", label: "Transaction" },
//     // { name: "CustomerLedger", label: "Customer Ledger" },
//     { name: "audit", label: "Audit Trail" },
//   ];

//      const onViewEasyRewardzDashboard=async()=>{
//         setLoading(true);
//         let response = await getEasyRewardWorkflowWidget(registration.key,
//             store.StoreCode,
//             customerData.PhoneNo
//             )
//         if(response.Success){
//             let url = response.Data.WidgetURL;
//             window.open(url,"_blank");
//             setLoading(false);
//         }
//         else{
//             toast.error("Unable to open EasyRewardz dashboard");
//             setLoading(false);
//         }

//     }

//   const deleteCustomerData = async () => {
//     try {
//       setOpenDeleteConfirm(false);
//       setLoading(true);
//       const response = await deleteCustomer(customerData.key);
//       if (response && response.code === "0") {
//         toast.success("Customer deleted successfully");
//       } else {
//         toast.error("Failed to delete customer");
//       }
//     } catch (error) {
//       console.error("Failed to delete customer", error);
//       toast.error("Failed to delete customer");
//     } finally {
//       setTimeout(() => {
//         handleOnDelete();
//         setLoading(false);
//       }, 3000);
//     }
//   };

//   // Animation variants
//   const cardVariants = {
//     hidden: { opacity: 0, y: 20 },
//     visible: { opacity: 1, y: 0 }
//   };

//   return (
//     <>
//       <ViewPage
//         handleRemoveBtnClick={handleCancelClick}
//         highLightFirstLetter={customerData?.FirstName?.[0]}
//         name={` ${customerData?.FirstName} ${customerData?.LastName}`}
//         description={
//           <div className="flex flex-wrap items-center gap-2">
//             {/* Phone */}
//             {customerData?.PhoneNo && (
//               <a
//                 href={`tel:${customerData.PhoneNo}`}
//                 className="flex items-center gap-2 px-3 py-1.5 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors group"
//                 title="Click to call"
//               >
//                 <div className="w-7 p-1.5 bg-blue-100 rounded-full text-blue-600 group-hover:text-blue-700 transition-colors">
//                   <Icon type={"phone"} />
//                 </div>
//                 <span className="font-medium text-gray-700">{customerData.PhoneNo}</span>
//               </a>
//             )}

//             {/* Email */}
//             {customerData?.EmailID && (
//               <a
//                 href={`mailto:${customerData.EmailID}`}
//                 className="flex items-center gap-2 px-3 py-1.5 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors group"
//                 title="Click to email"
//               >
//                 <div className="w-7 p-1.5 bg-blue-100 rounded-full text-blue-600 group-hover:text-blue-700 transition-colors">
//                   <Icon type={"email"} />
//                 </div>
//                 <span className="font-medium text-gray-700 truncate max-w-[180px]">{customerData.EmailID}</span>
//               </a>
//             )}

//             {/* Total Spent */}
//             {apiData?.dashboardHeaders?.searchResult?.total_spent !== 0 && (
//               <div className="flex items-center gap-2 px-3 py-1.5 bg-gray-100 rounded-lg">
//                 <div className="w-7 h-7 p-1 bg-purple-100 rounded-full text-purple-600 flex items-center justify-center">
//                   {currencySymbol}
//                 </div>
//                 <span className="font-medium text-gray-700">
//                   {currencySymbol} {roundUpTo2(apiData?.dashboardHeaders?.searchResult?.total_spent)}
//                 </span>
//               </div>
//             )}

//             {/* Transactions */}
//             {apiData?.dashboardHeaders?.searchResult?.total_transactions !== 0 && (
//               <div className="flex items-center gap-2 px-3 py-1.5 bg-gray-100 rounded-lg">
//                 <div className="w-7 p-1 bg-green-100 rounded-full text-green-600">
//                   <Icon type={"totalTransaction"} />
//                 </div>
//                 <span className="font-medium text-gray-700">
//                   {apiData?.dashboardHeaders?.searchResult?.total_transactions} trans
//                 </span>
//               </div>
//             )}

//             {/* Outstanding */}
//             {customerData?.OutStandingAmount !== 0 && (
//               <div className="flex items-center gap-2 px-3 py-1.5 bg-gray-100 rounded-lg">
//                 <div className="w-7 p-1 bg-red-100 rounded-full text-red-600">
//                   <Icon type={"alert-circle"} />
//                 </div>
//                 <span className="font-medium text-gray-700">
//                   {currencySymbol} {roundUpTo2(customerData?.OutStandingAmount)} due
//                 </span>
//               </div>
//             )}

//             {/* Wallet Amount */}
//             {customerData?.WalletBalance !== 0 && (
//               <div className="flex items-center gap-2 px-3 py-1.5 bg-gray-100 rounded-lg">
//                 <div className="w-7 p-1 bg-indigo-100 rounded-full text-indigo-600">
//                   <Icon type={"wallet"} />
//                 </div>
//                 <span className="font-medium text-gray-700">
//                   {currencySymbol} {roundUpTo2(customerData?.WalletBalance)} wallet
//                 </span>
//               </div>
//             )}

//             {/* Loyalty Points */}
//             {hasValue(loyalty?.LoyaltyPoints) && (
//               <div className="flex items-center gap-2 px-3 py-1.5 bg-gray-100 rounded-lg">
//                 <div className="w-7 p-1 bg-amber-100 rounded-full text-amber-600">
//                   <Icon type={"loyalty"} />
//                 </div>
//                 <span className="font-medium text-gray-700">
//                   <span className="mr-1">{loyalty.LoyaltyType}</span>
//                   {roundUpTo2(loyalty.LoyaltyPoints)} pts
//                 </span>
//               </div>
//             )}
//             {customerData?.Membership?.Name && (
//               <div className="flex items-center gap-2 px-3 py-1.5 bg-gray-100 rounded-lg">
//                 <div className="w-7 p-1 bg-amber-100 rounded-full text-amber-600">
//                   <Icon type={"membership"} />
//                 </div>
//                 <span className="font-medium text-gray-700">
//                   {customerData.Membership.Name}
//                 </span>
//               </div>
//             )}
//           </div>
//         }
//         iconButtons={[
//           ...(!customerData?.IsDeleted && getVisibility("Customers","update") ? [{
//             label: "Edit",
//             onClick: () => handleEditClick(),
//             icon: <Icon type="edit" />,
//             tooltipWidth: "70px"
//           }] : []),
//           ...(!customerData?.IsDeleted && getVisibility("Customers","delete") ? [{
//             label: "Delete Customer",
//             onClick: () => setOpenDeleteConfirm(true),
//             icon: <Icon type="delete" />,
//             tooltipWidth: "150px"
//           }] : []),
//         ]}
//         tabs={
//           <Tab
//             tabs={tabs}
//             activeTab={activeTab}
//             onTabChange={setActiveTab}
//             className="sticky top-0 z-10 bg-white"
//           />
//         }
//       >
//         {loading ? (
//           <div className="flex justify-center items-center h-64">
//             <Loading size="lg" />
//           </div>
//         ) : (
//           <div className="p-4">
//             {activeTab === "Overview" && (
//               <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
//                 {/* Left Side - Client Details */}

//                 {/* General Details */}
//                 <div>
//                   <DetailTable title="General Details" mt="mt-[10px]">
//                     <DetailRow label="Gender" value={customerData?.Gender} />
//                     <DetailRow
//                       label="Date Of Birth"
//                       value={
//                         `${customerData?.DOBNew?.Day || ''}${customerData?.DOBNew?.Month ? ` ${customerData?.DOBNew?.Month}` : ''
//                           }${customerData?.DOBNew?.Year ? ` ${customerData.DOBNew.Year}` : ''
//                           }`.trim()
//                       }
//                     />
//                     <DetailRow
//                       label="Anniversary"
//                       value={
//                         `${customerData?.AnniversaryNew?.Day || ''}${customerData?.AnniversaryNew?.Month ? ` ${customerData?.AnniversaryNew.Month}` : ''
//                           }${customerData?.AnniversaryNew?.Year ? ` ${customerData?.AnniversaryNew.Year}` : ''
//                           }`.trim()
//                       }
//                     />
//                     <DetailRow label="Notes" value={customerData?.Note} />
//                     <DetailRow label="Customer Code" value={customerData?.CustomerCode} />
//                     {[1, 2, 3, 4, 5, 6].map(num => (
//                       <DetailRow
//                         label={customerCustomFieldData[`CustomField${num}Name`] || `Custom Field ${num}`}
//                         value={customerData?.[`CustomField${num}`]}
//                       />
//                     ))}
//                   </DetailTable>

//                   {registration?.BusinessTypeID=="7" && <DetailTable title="Pet Details">
//                     <div className="flex flex-col space-y-5">
//  {customerData?.PetDetails?.length > 0 ? (
//                       customerData.PetDetails.map((pet, index) => (
//                         <DetailTable
//                           title={pet?.Type}
//                           mt=""
//                         >
//                             <DetailRow label="Name" value={pet?.PetName} />
//                           <DetailRow label="Gender" value={pet?.Gender} />
//                           <DetailRow label="Date Of Birth" value={pet?.Dob} />
//                           <DetailRow label="Breed" value={pet?.Breed} />
//                           <DetailRow label="Height" value={pet?.Height} />
//                           <DetailRow label="Weight" value={pet?.Weight} />
//                         </DetailTable>
//                       ))
//                     ) : (
//                       <div>No pet found</div>
//                     )}
//                     </div>
                   
//                   </DetailTable>}

//                   <DetailTable title="Address">
//                     {customerData?.Addresses?.length > 0 ? (
//                       customerData.Addresses.map((address, index) => (
//                         <DetailTable
//                           key={index}
//                           title={address?.AddressType || 'Address'}
//                           mt="mt-[2px]"
//                         >
//                           <DetailRow label="Line Address 1" value={address?.Address1 || '-'} />
//                           <DetailRow label="Line Address 2" value={address?.Address2 || '-'} />
//                           <DetailRow label="City" value={address?.City || '-'} />
//                           <DetailRow label="State" value={address?.State || '-'} />
//                           <DetailRow label="Postal Code" value={address?.PostalCode || '-'} />
//                         </DetailTable>
//                       ))
//                     ) : (
//                       <div>No address found</div>
//                     )}
//                   </DetailTable>
//                 </div>

//                 {/* Right Side - Overview Data */}
//                 <div className="mt-[10px]">
//                   {/* Top Products */}
//                   <div
//                     className="bg-white rounded-lg shadow-sm p-5 border border-gray-100 hover:shadow-md transition-all"
//                   >
//                     <div className="flex items-center justify-between mb-4">
//                       <h3 className="font-semibold text-[16px] flex items-center gap-2">
//                         Top Purchases
//                       </h3>
//                     </div>

//                     {topFiveProductsRows.length > 0 ? (
//                       <div className="space-y-4">
//                         {topFiveProductsRows.map((product, index) => (
//                           <div
//                             key={product.id}
//                             className={`flex items-start p-3 rounded-lg hover:bg-gray-50 transition-colors ${index !== topFiveProductsRows.length - 1 ? 'border-b border-gray-100' : ''}`}
//                           >
//                             <span className="text-sm bg-gray-100 px-2 py-1 rounded-lg mr-3 mt-1">
//                               #{index + 1}
//                             </span>
//                             <div className="flex-1">
//                               <h4 className="font-medium">{product.productName}</h4>
//                               <div className="flex items-center mt-1  text-(--tab-gray)">
//                                 <span>Qty: {product.totalQty}</span>
//                                 <span className="mx-2">•</span>
//                                 <span>Sales: {product.totalSales}</span>
//                               </div>
//                             </div>
//                           </div>
//                         ))}
//                       </div>
//                     ) : (
//                       <div className="flex justify-center items-center py-8 text-(--tab-gray)">
//                         No purchases found
//                       </div>
//                     )}
//                   </div>

//                   {/* Recent Purchase */}
//                   <div
//                     className="bg-white rounded-lg shadow-sm p-5 border border-gray-100 hover:shadow-md transition-all mt-5"
//                   >
//                     <div className="flex items-center justify-between mb-4">
//                       <h3 className="font-semibold text-[16px]  flex items-center gap-2">
//                         Recent Purchase
//                       </h3>
//                     </div>

//                     {apiData?.transactions?.searchResult[0] ? (
//                       <div className="space-y-4">
//                         {customerData.LastVisitedOn && (
//                           <div className="flex items-center">
//                             <span className=" bg-[#eff6ff] px-2 py-1 rounded-lg">
//                               <span className=" text-(--tab-gray)">Last Visited:</span>
//                               {customerData?.LastVisitedOn && (() => {
//                                 const daysDiff = Math.floor((new Date() - new Date(customerData.LastVisitedOn)) / (1000 * 60 * 60 * 24));
//                                 return daysDiff <= 30 ? (
//                                   <span className="ml-2">
//                                     {daysDiff === 0 ? 'today' : `${daysDiff} day${daysDiff !== 1 ? 's' : ''} ago `}
//                                   </span>
//                                 ) : null;
//                               })()}
//                               {customerData?.LastVisitedOn
//                                 ? `( ${new Date(customerData.LastVisitedOn).toLocaleDateString('en-US', {
//                                   day: 'numeric',
//                                   month: 'short',
//                                   year: 'numeric',
//                                   hour: '2-digit',
//                                   minute: '2-digit'
//                                 })} )`
//                                 : ''}
//                             </span>
//                           </div>
//                         )}

//                         <div className="space-y-3">
//                           <div className="text-[#6E2D90] flex items-center space-x-2">
//                             <span className="cursor-pointer" onClick={() => { setViewTransaction(!viewTransaction) }} >View Transaction </span><span className="w-5 cursor-pointer" onClick={() => { setViewTransaction(!viewTransaction) }}><Icon type={`${viewTransaction ? "uparrow" : "downarrow"}`} /></span>
//                           </div>
//                           {viewTransaction && (
//                             <>
//                               <div>
//                                 <span className="text-(--tab-gray)">Transaction No:</span>
//                                 <span className="ml-1 font-medium">{customerData.LastTransactionNo}</span>
//                               </div>

//                               {apiData?.transactions?.searchResult[0]?.LineItems.map((lineitem, index) => (
//                                 <div className="bg-gray-50 p-3 rounded-lg mt-2">
//                                   <h4 className="font-medium">{lineitem.Product.Name}</h4>
//                                   <div className="mt-1">
//                                     <div className="grid grid-cols-2 gap-1">
//                                       <div>
//                                         <span className="text-(--tab-gray)">Qty:</span>
//                                         <span className="ml-1 font-medium">{lineitem.Qty}</span>
//                                       </div>
//                                       <div>
//                                         <span className="text-(--tab-gray)">Price:</span>
//                                         <span className="ml-1 font-medium">{currencySymbol} {lineitem.RetailPrice}</span>
//                                       </div>
//                                       <div>
//                                         <span className="text-(--tab-gray)">Amount:</span>
//                                         <span className="ml-1 font-medium">{currencySymbol} {lineitem.Amount}</span>
//                                       </div>
//                                       <div>
//                                         <span className="text-(--tab-gray)">Discount:</span>
//                                         <span className="ml-1 font-medium">
//                                           {lineitem?.DiscountAmount
//                                             ? `${currencySymbol}${roundUpTo2(lineitem.DiscountAmount)} (${lineitem.DiscountPer}%)`
//                                             : 'N/A'
//                                           }
//                                         </span>
//                                       </div>
//                                     </div>
//                                   </div>
//                                 </div>
//                               ))}
//                             </>
//                           )}
//                         </div>
//                       </div>
//                     ) : (
//                       <div className="flex justify-center items-center py-8 text-(--tab-gray)">
//                         No recent purchases found
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             )}

//             {activeTab === "Transaction" && (
//               <div>
//                 <div className="sticky top-0 z-10 bg-white pb-4">
//                   <Tab
//                     showBorder={true}
//                     tabs={[
//                       { label: "Sales", name: "Sales" },
//                       ...(walletRows.length > 0 ? [{ label: "Wallet", name: "Wallet" }] : []),
//                       ...((registration?.EnableEasyRewardz || loyaltyRows.length > 0) ? [{ label: "Loyalty Ledger", name: "Loyalty Ledger" }] : []),
//                       ...(packageRows.length > 0 ? [{ label: "Packages", name: "Packages" }] : [])
//                     ]}
//                     activeTab={transactionActiveTab}
//                     onTabChange={setTransactionActiveTab}
//                     mt={"mt-0"}
//                   />
//                 </div>

//                 <div>
//                   {transactionActiveTab === "Loyalty Ledger" && (
//                     <div className="bg-white rounded-lg  overflow-hidden">
//                       {!registration?.EnableEasyRewardz &&<CustomTable
//                         columns={loyaltyColumns}
//                         rows={loyaltyRows}
//                         showTextOnRows={loyaltyRows.length > 0 ? "" : "No data found"}
//                       />}
//                       {registration.EnableEasyRewardz && <Button type="secondary" onClick={onViewEasyRewardzDashboard}>View EasyRewardz Dashboard</Button>}

                      
//                     </div>
//                   )}

//                   {transactionActiveTab === "Wallet" && (
//                     <div className="bg-white rounded-lg shadow-sm overflow-hidden">
//                       <CustomTable
//                         columns={walletColumns}
//                         rows={walletRows}
//                         showTextOnRows={walletRows.length > 0 ? "" : "No data found"}
//                       />
//                     </div>
//                   )}

//                   {transactionActiveTab === "Packages" && (
//                     <div className="bg-white rounded-lg shadow-sm overflow-hidden">
//                       <CustomTable
//                         columns={packageColumns}
//                         rows={packageRows}
//                         showTextOnRows={packageRows.length > 0 ? "" : "No data found"}
//                       />
//                     </div>
//                   )}

//                   {transactionActiveTab === "Sales" && (
//                     <div className="bg-white rounded-lg shadow-sm overflow-hidden">
//                       <CustomTable
//                         columns={transactionColumns}
//                         rows={transactionRows}
//                         showTextOnRows={transactionRows.length > 0 ? "" : "No data found"}
//                       />
//                     </div>
//                   )}
//                 </div>
//               </div>
//             )}

//             {activeTab === "CustomerLedger" && (
//               <div className="space-y-6">
//                 {/* Filter Section */}
//                 {/* <div className="bg-white rounded-xl shadow-sm p-6 border border-gray-200">
//                   <h3 className="text-lg font-semibold text-gray-800 mb-4">Filter Ledger</h3>
//                   <div className="flex flex-col md:flex-row gap-4">
//                     <div className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-4">
//                       <div>
//                         <label className="block text-sm font-medium text-gray-700 mb-2">
//                           From Date
//                         </label>
//                         <input
//                           type="date"
//                           value={fromDate ? fromDate.toISOString().split('T')[0] : ''}
//                           onChange={(e) => setFromDate(e.target.value ? new Date(e.target.value) : null)}
//                           className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
//                         />
//                       </div>
//                       <div>
//                         <label className="block text-sm font-medium text-gray-700 mb-2">
//                           To Date
//                         </label>
//                         <input
//                           type="date"
//                           value={toDate ? toDate.toISOString().split('T')[0] : ''}
//                           onChange={(e) => setToDate(e.target.value ? new Date(e.target.value) : null)}
//                           className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
//                         />
//                       </div>
//                     </div>
                    
//                     <div className="flex items-end gap-3">
//                       <button
//                         onClick={handleLedgerFilter}
//                         disabled={ledgerLoading}
//                         className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2.5 rounded-lg font-medium flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed transition"
//                       >
//                         {ledgerLoading ? (
//                           <>
//                             <Loading size="sm" />
//                             Loading...
//                           </>
//                         ) : (
//                           <>
//                             <Icon type="filter" className="w-5 h-5" />
//                             Apply Filter
//                           </>
//                         )}
//                       </button>
//                       <button
//                         onClick={handleResetFilter}
//                         className="bg-gray-100 hover:bg-gray-200 text-gray-700 px-6 py-2.5 rounded-lg font-medium flex items-center gap-2 transition"
//                       >
//                         <Icon type="refresh" className="w-5 h-5" />
//                         Reset
//                       </button>
//                     </div>
//                   </div>
//                 </div> */}

//                 {/* Filter Section */}
//                 <div className="bg-white rounded-xl shadow-sm p-6 border border-gray-200">
//                   <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
//                     <div className="flex-1">
//                       <h3 className="text-lg font-semibold text-gray-800 mb-4">Customer Ledger</h3>
//                       <div className="flex flex-col sm:flex-row items-start sm:items-end gap-4">
//                         <div className="flex-1">
//                           <label className="block text-sm font-medium text-gray-700 mb-2">
//                             From Date
//                           </label>
//                           <div className="flex gap-2">
//                             <input
//                               type="date"
//                               value={fromDate ? fromDate.toISOString().split('T')[0] : ''}
//                               onChange={(e) => setFromDate(e.target.value ? new Date(e.target.value) : null)}
//                               className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
//                             />
//                             <button
//                               onClick={handleLedgerFilter}
//                               disabled={ledgerLoading}
//                               className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2.5 rounded-lg font-medium flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed transition whitespace-nowrap h-[42.5px]"
//                             >
//                               {ledgerLoading ? (
//                                 <>
//                                   <Loading size="sm" />
//                                   Loading...
//                                 </>
//                               ) : (
//                                 <>
//                                   <Icon type="eye" className="w-5 h-5" />
//                                   View
//                                 </>
//                               )}
//                             </button>
//                           </div>
//                         </div>

//                         <div className="flex items-end gap-3 h-[42.5px]">
//                           <button
//                             onClick={downloadCSV}
//                             disabled={customerLedgerData.length === 0}
//                             className="bg-green-600 hover:bg-green-700 text-white px-5 py-2.5 rounded-lg font-medium flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed transition h-full"
//                             title="Download CSV"
//                           >
//                             <Icon type="download" className="w-5 h-5" />
//                             <span className="hidden sm:inline">Download CSV</span>
//                             <span className="inline sm:hidden">CSV</span>
//                           </button>
//                           <button
//                             onClick={downloadPDF}
//                             disabled={customerLedgerData.length === 0}
//                             className="bg-red-600 hover:bg-red-700 text-white px-5 py-2.5 rounded-lg font-medium flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed transition h-full"
//                             title="Download PDF"
//                           >
//                             <Icon type="download" className="w-5 h-5" />
//                             <span className="hidden sm:inline">Download PDF</span>
//                             <span className="inline sm:hidden">PDF</span>
//                           </button>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 {/* Download Buttons */}
//                 {/* <div className="flex flex-wrap gap-3">
//                   <button
//                     onClick={downloadCSV}
//                     disabled={customerLedgerData.length === 0}
//                     className="bg-green-600 hover:bg-green-700 text-white px-5 py-2.5 rounded-lg font-medium flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed transition"
//                   >
//                     <Icon type="download" className="w-5 h-5" />
//                     Download CSV
//                   </button>
//                   <button
//                     onClick={downloadPDF}
//                     disabled={customerLedgerData.length === 0}
//                     className="bg-red-600 hover:bg-red-700 text-white px-5 py-2.5 rounded-lg font-medium flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed transition"
//                   >
//                     <Icon type="download" className="w-5 h-5" />
//                     Download PDF
//                   </button>
//                 </div> */}

//                 {/* Summary Cards */}
//                 {customerLedgerData.length > 0 && (
//                   <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//                     <div className="bg-gradient-to-r from-red-50 to-red-100 border-2 border-red-200 rounded-xl p-6 shadow-sm">
//                       <div className="flex items-center justify-between">
//                         <div>
//                           <p className="text-sm font-medium text-red-600">Total Debit</p>
//                           <p className="text-2xl font-bold text-red-700 mt-1">
//                             {currencySymbol} {roundUpTo2(customerLedgerData.reduce((sum, item) => sum + (item.debit || 0), 0))}
//                           </p>
//                         </div>
//                         <div className="p-3 bg-red-200 rounded-full">
//                           <Icon type="arrow-down" className="w-6 h-6 text-red-600" />
//                         </div>
//                       </div>
//                     </div>

//                     <div className="bg-gradient-to-r from-green-50 to-green-100 border-2 border-green-200 rounded-xl p-6 shadow-sm">
//                       <div className="flex items-center justify-between">
//                         <div>
//                           <p className="text-sm font-medium text-green-600">Total Credit</p>
//                           <p className="text-2xl font-bold text-green-700 mt-1">
//                             {currencySymbol} {roundUpTo2(customerLedgerData.reduce((sum, item) => sum + (item.credit || 0), 0))}
//                           </p>
//                         </div>
//                         <div className="p-3 bg-green-200 rounded-full">
//                           <Icon type="arrow-up" className="w-6 h-6 text-green-600" />
//                         </div>
//                       </div>
//                     </div>

//                     <div className="bg-gradient-to-r from-blue-50 to-blue-100 border-2 border-blue-200 rounded-xl p-6 shadow-sm">
//                       <div className="flex items-center justify-between">
//                         <div>
//                           <p className="text-sm font-medium text-blue-600">Net Balance</p>
//                           <p className={`text-2xl font-bold mt-1 ${customerLedgerData.reduce((sum, item) => sum + ((item.debit || 0) - (item.credit || 0)), 0) < 0 ? 'text-red-700' : 'text-blue-700'}`}>
//                             {currencySymbol} {roundUpTo2(customerLedgerData.reduce((sum, item) => sum + ((item.debit || 0) - (item.credit || 0)), 0))}
//                           </p>
//                         </div>
//                         <div className="p-3 bg-blue-200 rounded-full">
//                           <Icon type="balance" className="w-6 h-6 text-blue-600" />
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 )}

//                 {/* Table Section */}
//                 <div className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-200">
//                   <div className="p-6 border-b border-gray-200 bg-gradient-to-r from-gray-50 to-white">
//                     <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
//                       <div>
//                         <h3 className="text-xl font-bold text-gray-800">Customer Ledger</h3>
//                         <p className="text-sm text-gray-600 mt-1">
//                           Transaction history for {customerData?.FirstName} {customerData?.LastName}
//                         </p>
//                       </div>
//                       <div className="text-sm font-medium px-4 py-2 bg-blue-50 text-blue-700 rounded-lg">
//                         Total Records: <span className="font-bold">{customerLedgerData.length}</span>
//                       </div>
//                     </div>
//                   </div>

//                   {ledgerLoading ? (
//                     <div className="flex flex-col justify-center items-center h-64">
//                       <Loading size="lg" />
//                       <p className="mt-4 text-gray-600 font-medium">Loading ledger data...</p>
//                     </div>
//                   ) : customerLedgerData.length > 0 ? (
//                     <CustomTable
//                       columns={ledgerColumns}
//                       rows={customerLedgerData.map((item, index) => ({
//                         id: index,
//                         transactionNo: item.transactionNo || 'N/A',
//                         transactionType: item.transactionType || 'N/A',
//                         customerName: item.customerName || 'N/A',
//                         debit: item.debit || 0,
//                         credit: item.credit || 0,
//                         Balance: item.Balance || 0,
//                         Narration: item.Narration || 'No narration'
//                       }))}
//                       className="min-h-[500px]"
//                       showTextOnRows=""
//                     />
//                   ) : (
//                     <div className="flex flex-col justify-center items-center h-96 text-center p-8">
//                       <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mb-6">
//                         <Icon type="file-text" className="w-12 h-12 text-gray-400" />
//                       </div>
//                       <h4 className="text-xl font-semibold text-gray-700 mb-2">No Ledger Data Found</h4>
//                       <p className="text-gray-500 max-w-md">
//                         No transaction records available for the selected date range.
//                         Try adjusting your filters or check back later for updates.
//                       </p>
//                       <button
//                         onClick={handleResetFilter}
//                         className="mt-6 px-6 py-3 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition"
//                       >
//                         Reset Filters
//                       </button>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             )}

//             {activeTab === "audit" && (
//               <AuditTrail data={auditTrails} loading={AuditTrailLoading} />
//             )}
//           </div>
//         )}
//       </ViewPage>

//       {openDeleteConfirm && (
//         <ConfirmBox
//           title={
//             <>
//               Are you sure you want to delete{" "}
//               <span className="text-red-700">{customerData?.FirstName}</span>?
//             </>
//           }
//           text="This action cannot be undone."
//           onConfirm={deleteCustomerData}
//           onCancel={() => setOpenDeleteConfirm(false)}
//         />
//       )}
//     </>
//   );
// };

// export default CustomerDetail;

import IconButton from "../../controls/IconButton";
import Icon from "../../../assets/icons/Icon";
import Loading from "../../controls/Loading";
import CustomTable from "../../controls/CustomTable";
import { deleteCustomer, fetchCustomerAudittrails, getCustomerDashboardHeaders, getCustomerDetails, getCustomerEasyRewardzLoyaltyPoints, getCustomerLoyaltyPoints, getCustomerMLoyalLoyaltyPoints, getCustomerPackages, getCustomerProducts, getCustomerTransactions, getEasyRewardWorkflowWidget, getLoyaltyLedgersByCustomerID, getPastAppointmentsForCustomer, getUpcomingAppointmentsForCustomer, getWalletLedgersByCustomerID } from "../../../api/CustomerApi";
import { useSelector } from "react-redux";
import { selectCustomerModule } from "../../../redux/slices/customFieldSlice";
import { useState, useEffect } from "react";
import ViewPage from "../../controls/ViewPage";
import Tab from "../../controls/Tab";
import ConfirmBox from "../../controls/ConfirmBox";
import useCurrencySymbol from "../../controls/CurrencySymbol";
import { toast } from "react-toastify";
import DetailTable from "../../controls/DetailTable";
import DetailRow from "../../controls/DetailRow";
import AuditTrail from "../../controls/AuditTrail";
import axios from "axios";
import { registerVersion } from "firebase/app";
import { selectRegistration } from "../../../redux/slices/userSlice";
import { hasValue, isMobileView, useAcl } from "../../controls/CommonFunctions";
import Button from "../../controls/Button";
const CustomerDetail = ({ customerData, handleCancelClick, handleEditClick, handleOnDelete }) => {
  console.log("custoemrData",customerData)
      const { getVisibility } = useAcl();
  const [activeTab, setActiveTab] = useState("Overview");
  const [apiData, setApiData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [transactionActiveTab, setTransactionActiveTab] = useState("Sales");
  const currencySymbol = useCurrencySymbol();
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const [isHovering, setIsHovering] = useState(false);
  const [viewTransaction, setViewTransaction] = useState(false);
  const [auditTrails, setAuditTrails] = useState([]);
  const [AuditTrailLoading, setAuditTrailLoading] = useState(false);
  const registration=useSelector(selectRegistration);
  const store = useSelector((state) => state.store.store);
  console.log("registration",registration);
  // Customer Ledger States
  const [customerLedgerData, setCustomerLedgerData] = useState([]);
  const [ledgerLoading, setLedgerLoading] = useState(false);
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(null);
  const [loyalty,setLoyalty]=useState({});

  const customerCustomFieldData = useSelector(selectCustomerModule);
const SEGMENT_COLORS = {
    Champions: "bg-green-100 text-green-700 border-green-200",
    "Loyal Customers": "bg-blue-100 text-blue-700 border-blue-200",
    "Potential Loyalist": "bg-purple-100 text-purple-700 border-purple-200",
    "New Customers": "bg-indigo-100 text-indigo-700 border-indigo-200",
    "At Risk": "bg-red-100 text-red-700 border-red-200",
    "New Promising": "bg-yellow-100 text-yellow-700 border-yellow-200",
    Lost: "bg-gray-200 text-gray-700 border-gray-300",
    //Others: "bg-gray-100 text-gray-600 border-gray-200",
  };
  const fetchCustomerLoyalty=async()=>{
    try{
      const response=await    getCustomerLoyaltyPoints(customerData?.key);
      if(response?.code=="0"){
      setLoyalty(response?.LoyaltyCustomer);
      }
      else{
      toast.error(response?.message || "Failed to fetch loyalty");
      setLoyalty({});
      }
    }
    catch(error){
     toast.error("Failed to fetch loyalty");
       setLoyalty({});
    }
  }

  const fetchAllApis = async (customerID) => {
    setLoading(true);
    try {
      const [
        dashboardHeaders,
        transactions,
        products,
        walletLedgers,
        packages,
        loyaltyLedgers,
        upcomingAppointments,
        pastAppointments,
      ] = await Promise.all([
        getCustomerDashboardHeaders(customerID),
        getCustomerTransactions(customerID),
        getCustomerProducts(customerID),
        getWalletLedgersByCustomerID(0,20,customerID),
        getCustomerPackages(customerID),
        getLoyaltyLedgersByCustomerID(customerID),
        getUpcomingAppointmentsForCustomer(customerID),
        getPastAppointmentsForCustomer(customerID),
     
      ].map(p => p.catch(error => {
        console.error('Error in API call:', error);
        return null;
      })));

      setApiData({
        dashboardHeaders,
        transactions,
        products,
        walletLedgers,
        packages,
        loyaltyLedgers,
        upcomingAppointments,
        pastAppointments,
      });
    } catch (error) {
      console.error('Unexpected error in Promise.all:', error);
      toast.error("Failed to load customer data");
    } finally {
      setLoading(false);
    }
  };

  const fetchAuditTrailsData = async (key) => {
    setAuditTrailLoading(true);
    try {
      const response = await fetchCustomerAudittrails(key);
      setAuditTrails(response.data);
    } catch (error) {
      console.log("error", error);
      toast.error("Failed to load data !");
    } finally {
      setAuditTrailLoading(false);
    }
  };

  // Fetch Customer Ledger Data
  const fetchCustomerLedger = async (customerId, fromDate, toDate) => {
    setLedgerLoading(true);
    try {
      const requestBody = {
        customerId: customerId,
      };

      // Add dates only if they exist
      if (fromDate) {
        requestBody.fromDate = fromDate.getTime().toString();
      }
      if (toDate) {
        requestBody.toDate = toDate.getTime().toString();
      }

      const response = await axios.post(
        "https://pincodebackgroundprocess-2qevtrwogq-el.a.run.app/report/customer/ledger",
        requestBody,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("response", response);

      const data = response.data?.reportData || [];
      setCustomerLedgerData(data);

    } catch (error) {
      console.error("Error fetching customer ledger:", error);
      toast.error("Failed to load customer ledger data");
    } finally {
      setLedgerLoading(false);
    }
  };

  const roundUpTo2 = (num) => {
    return Math.round(Number(num) * 100) / 100;
  }

  const initialization=async()=>{
       if(registration?.LoyaltyEnabled){
 fetchCustomerLoyalty();
      }
       if(registration?.EnableMLoyal){
               const response=await getCustomerMLoyalLoyaltyPoints(registration?.key, 
                      store.key, 
                        customerData?.key, 
                        customerData?.PhoneNo);


                         setLoyalty({
                                LoyaltyType:response.CUSTOMER_DETAILS[0].Slab + " (Pt: " + response.CUSTOMER_DETAILS[0].LoyalityPoints + ", Vl: " + response.CUSTOMER_DETAILS[0].LoyalityPointsValue + ")",
                                LoyaltyPoints:response.CUSTOMER_DETAILS[0].LoyalityPoints
                            });

                }

                  if(registration?.EnableEasyRewardz){
               const response=await getCustomerEasyRewardzLoyaltyPoints(registration.key, 
                        store.key, 
                        store.StoreCode, 
                        customerData?.key, 
                        customerData?.PhoneNo);


                         setLoyalty({
                                LoyaltyType:"Loyalty",
                                    LoyaltyPoints:response.Data.AvailablePoints
                            });

                }
  }
  useEffect(() => {
    if (customerData?.key) {
     initialization();
     
      fetchAllApis(customerData.key);
      fetchAuditTrailsData(customerData.key);
      // Fetch ledger data on initial load
      fetchCustomerLedger(customerData.key, null, null);
    }
  }, [customerData?.key]);

  // Handle Date Filter Change for Ledger
  const handleLedgerFilter = () => {
    if (customerData?.key) {
      fetchCustomerLedger(customerData.key, fromDate, toDate);
    }
  };

  // Reset Date Filter
  const handleResetFilter = () => {
    setFromDate(null);
    setToDate(null);
    if (customerData?.key) {
      fetchCustomerLedger(customerData.key, null, null);
    }
  };

  // Download CSV
  const downloadCSV = () => {
    if (customerLedgerData.length === 0) {
      toast.warning("No data to download");
      return;
    }

    const headers = ["Transaction No", "Transaction Type", "Customer Name", "Debit", "Credit", "Balance", "Narration"];

    const csvRows = customerLedgerData.map(item => [
      `"${item.transactionNo || ''}"`,
      `"${item.transactionType || ''}"`,
      `"${item.customerName || ''}"`,
      item.debit || '0',
      item.credit || '0',
      item.Balance || '0',
      `"${item.Narration || ''}"`
    ]);

    const csvContent = [
      headers.join(','),
      ...csvRows.map(row => row.join(','))
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `customer_ledger_${customerData?.FirstName || 'customer'}_${new Date().toISOString().split('T')[0]}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);

    toast.success("CSV download started");
  };

  // Download PDF (Placeholder - you need to implement actual PDF generation)
  // const downloadPDF = () => {
  //   if (customerLedgerData.length === 0) {
  //     toast.warning("No data to download");
  //     return;
  //   }

  //   toast.info("PDF download functionality coming soon");
  // };

  const downloadPDF = () => {
    if (customerLedgerData.length === 0) {
      toast.warning("No data to download");
      return;
    }

    try {
      // Calculate totals
      const totalDebit = customerLedgerData.reduce((sum, item) => sum + (item.debit || 0), 0);
      const totalCredit = customerLedgerData.reduce((sum, item) => sum + (item.credit || 0), 0);
      const netBalance = totalDebit - totalCredit;

      // Create a new window for printing
      const printWindow = window.open('', '_blank');

      const htmlContent = `
      <!DOCTYPE html>
      <html>
      <head>
        <title>Customer Ledger - ${customerData?.FirstName || ''} ${customerData?.LastName || ''}</title>
        <style>
          @media print {
            @page {
              size: landscape;
              margin: 10mm;
            }
            
            body {
              font-family: Arial, sans-serif;
              margin: 0;
              padding: 20px;
            }
            
            .header {
              text-align: center;
              margin-bottom: 20px;
              padding-bottom: 10px;
              border-bottom: 2px solid #3498db;
            }
            
            .header h1 {
              color: #2c3e50;
              margin: 0;
              font-size: 24px;
            }
            
            .header h3 {
              color: #7f8c8d;
              margin: 5px 0 0 0;
              font-size: 16px;
            }
            
            .meta-info {
              display: flex;
              justify-content: space-between;
              margin-bottom: 20px;
              font-size: 12px;
              color: #666;
            }
            
            table {
              width: 100%;
              border-collapse: collapse;
              margin-bottom: 20px;
              font-size: 11px;
            }
            
            th {
              background-color: #3498db;
              color: white;
              font-weight: bold;
              padding: 8px;
              text-align: left;
              border: 1px solid #ddd;
            }
            
            td {
              padding: 8px;
              border: 1px solid #ddd;
            }
            
            tr:nth-child(even) {
              background-color: #f9f9f9;
            }
            
            .debit {
              text-align: right;
              color: #e74c3c;
              font-weight: bold;
            }
            
            .credit {
              text-align: right;
              color: #27ae60;
              font-weight: bold;
            }
            
            .balance {
              text-align: right;
              font-weight: bold;
            }
            
            .summary {
              margin-top: 30px;
              padding-top: 20px;
              border-top: 2px solid #3498db;
            }
            
            .summary-grid {
              display: flex;
              gap: 20px;
              margin-top: 10px;
            }
            
            .summary-card {
              padding: 15px;
              border-radius: 5px;
              min-width: 180px;
            }
            
            .debit-card {
              background-color: #f8d7da;
              border: 1px solid #f5c6cb;
            }
            
            .credit-card {
              background-color: #d4edda;
              border: 1px solid #c3e6cb;
            }
            
            .balance-card {
              background-color: ${netBalance < 0 ? '#f8d7da' : netBalance > 0 ? '#d4edda' : '#e2e3e5'};
              border: 1px solid ${netBalance < 0 ? '#f5c6cb' : netBalance > 0 ? '#c3e6cb' : '#d6d8d9'};
            }
            
            .footer {
              margin-top: 30px;
              text-align: center;
              font-size: 10px;
              color: #666;
              border-top: 1px solid #eee;
              padding-top: 10px;
            }
          }
          
          @media screen {
            body {
              font-family: Arial, sans-serif;
              margin: 20px;
              padding: 20px;
              background-color: #f5f5f5;
            }
            
            .print-container {
              max-width: 1200px;
              margin: 0 auto;
              background: white;
              padding: 30px;
              box-shadow: 0 0 10px rgba(0,0,0,0.1);
            }
          }
        </style>
      </head>
      <body>
        <div class="print-container">
          <div class="header">
            <h1>Customer Ledger Report</h1>
            <h3>${customerData?.FirstName || ''} ${customerData?.LastName || ''}</h3>
          </div>
          
          <div class="meta-info">
            <div>
              <strong>Generated on:</strong> ${new Date().toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })}
            </div>
            ${fromDate ? `
            <div>
              <strong>From Date:</strong> ${fromDate.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      })}
            </div>
            ` : ''}
            <div>
              <strong>Total Records:</strong> ${customerLedgerData.length}
            </div>
          </div>
          
          <table>
            <thead>
              <tr>
                <th>#</th>
                <th>Transaction No</th>
                <th>Transaction Type</th>
                <th>Customer Name</th>
                <th>Debit</th>
                <th>Credit</th>
                <th>Balance</th>
                <th>Narration</th>
              </tr>
            </thead>
            <tbody>
              ${customerLedgerData.map((item, index) => `
                <tr>
                  <td>${index + 1}</td>
                  <td>${item.transactionNo || 'N/A'}</td>
                  <td>${item.transactionType || 'N/A'}</td>
                  <td>${item.customerName || 'N/A'}</td>
                  <td class="debit">${currencySymbol} ${roundUpTo2(item.debit || 0)}</td>
                  <td class="credit">${currencySymbol} ${roundUpTo2(item.credit || 0)}</td>
                  <td class="balance" style="color: ${item.Balance < 0 ? '#e74c3c' : item.Balance > 0 ? '#27ae60' : '#2c3e50'}">
                    ${currencySymbol} ${roundUpTo2(item.Balance || 0)}
                  </td>
                  <td>${item.Narration || 'No narration'}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
          
          <div class="summary">
            <h3>Summary</h3>
            <div class="summary-grid">
              <div class="summary-card debit-card">
                <div><strong>Total Debit</strong></div>
                <div style="font-size: 18px; color: #721c24; margin-top: 5px;">
                  ${currencySymbol} ${roundUpTo2(totalDebit)}
                </div>
              </div>
              
              <div class="summary-card credit-card">
                <div><strong>Total Credit</strong></div>
                <div style="font-size: 18px; color: #155724; margin-top: 5px;">
                  ${currencySymbol} ${roundUpTo2(totalCredit)}
                </div>
              </div>
              
              <div class="summary-card balance-card">
                <div><strong>Net Balance</strong></div>
                <div style="font-size: 18px; color: ${netBalance < 0 ? '#721c24' : netBalance > 0 ? '#155724' : '#383d41'}; margin-top: 5px;">
                  ${currencySymbol} ${roundUpTo2(netBalance)}
                </div>
              </div>
            </div>
          </div>
          
          <div class="footer">
            <p>This is an auto-generated report. For any queries, please contact support.</p>
          </div>
        </div>
        
        <script>
          // Auto print and close
          window.onload = function() {
            setTimeout(function() {
              window.print();
              setTimeout(function() {
                window.close();
              }, 1000);
            }, 500);
          };
        </script>
      </body>
      </html>
    `;

      printWindow.document.write(htmlContent);
      printWindow.document.close();

      toast.success("Opening PDF print dialog...");

    } catch (error) {
      console.error("Error generating PDF:", error);
      toast.error("Failed to generate PDF");
    }
  };

  // Format data for tables
  const topFiveProductsRows = apiData?.products?.searchResult
    ?.map(product => ({
      ...product,
      total_quantity: parseFloat(product.total_quantity)
    }))
    ?.sort((a, b) => b.total_quantity - a.total_quantity)
    ?.slice(0, 5)
    ?.map((product, index) => ({
      id: index,
      productName: product.name,
      totalQty: product.total_quantity.toString(),
      totalSales: `${currencySymbol} ${roundUpTo2(product.total_sales)}`,
      productType: product.product_type
    })) || [];

  const productRows = apiData?.products?.searchResult
    ?.filter(product => product.product_type === "Goods for sale")
    ?.map((product, index) => ({
      id: index,
      productName: product.name,
      totalQty: product.total_quantity,
      totalSales: `${currencySymbol} ${roundUpTo2(product.total_sales)}`
    })) || [];

  const serviceRows = apiData?.products?.searchResult
    ?.filter(product => product.product_type === "Services")
    ?.map((product, index) => ({
      id: index,
      productName: product.name,
      totalSales: `${currencySymbol} ${roundUpTo2(product.total_sales)}`
    })) || [];

  const walletRows = apiData?.walletLedgers?.searchResult?.map((ledger, index) => ({
    id: index,
    date:ledger?.TransactionDate,
    narration: ledger.Narration,
    credit: ledger.Credit,
    debit: ledger.Debit,
    balance:ledger.Balance
  })) || [];

  const packageRows = apiData?.packages?.searchResult?.map((data, index) => ({
    id: index,
    transactionNo: data.TransactionNo,
    packageName: data.PackageName,
    packageStartDate: data.formattedStartDate,
    packageEndDate: data.formattedEndDate,
    packageStatus: data.PackageStatus,
  })) || [];

  const transactionRows = apiData?.transactions?.searchResult?.flatMap(transaction =>
    transaction.LineItems?.map((item, index) => ({
      id: `${transaction.key}-${index}`,
      transactionNo: transaction.TransactionNo,
      date: new Date(transaction.TransactionDate._seconds * 1000).toLocaleDateString(),
      product: item.Product?.Name,
      qty: item.Qty,
      retailPrice: `${currencySymbol} ${roundUpTo2(item.RetailPrice)}`,
      discount: item?.DiscountAmount ? `${currencySymbol} ${roundUpTo2(item?.DiscountAmount)}` : '-',
      discountPercentage: item?.DiscountPer,
      amount: `${currencySymbol} ${item.Amount}`
    })) || []
  ) || [];

  const loyaltyRows = apiData?.loyaltyLedgers?.searchResult?.map((ledger, index) => ({
    id: index,
    date: new Date(ledger.TransactionDate._seconds * 1000).toLocaleDateString(),
    narration: ledger.TransactionNo,
    earn: ledger.Type === 'earn' ? ledger.LoyaltyPoints : '',
    burn: ledger.Type === 'burn' ? ledger.LoyaltyPoints : '',
  })) || [];

  // Table columns
  const productColumns = [
    { field: "productName", headerName: "Product Name" },
    { field: "totalQty", headerName: "Total Qty", align: "right" },
    { field: "totalSales", headerName: "Total Sales", align: "right" },
  ];

  const serviceColumns = [
    { field: "productName", headerName: "Service Name" },
    { field: "totalSales", headerName: "Total Sales", align: "right" },
  ];

  const walletColumns = [
    { field: "date", headerName: "Date" },
    {
      field: "narration",
      headerName: "Narration",
    },
    { field: "credit", headerName: "Credit",type:"currency" },
    { field: "debit", headerName: "Debit", type:"currency" },
    { field: "balance", headerName: "Balance", type:"currency"},
  ];

  const packageColumns = [
    { field: "transactionNo", headerName: "Transaction No" },
    { field: "packageName", headerName: "Package Name" },
    { field: "packageStartDate", headerName: "Start Date" },
    { field: "packageEndDate", headerName: "End Date" },
    { field: "packageStatus", headerName: "Status" },
  ];

  const transactionColumns = [
    { field: "transactionNo", headerName: "Transaction No" },
    { field: "date", headerName: "Date" },
    {
      field: "",
      headerName: "Product",
      renderCell: ({ row }) => (
        <div className="text-wrap text-[14px] max-w-[100px]">{row.product}</div>
      ),
    },
    { field: "qty", headerName: "Qty", align: "right" },
    { field: "retailPrice", headerName: "Retail Price", align: "right" },
    { field: "discount", headerName: "Discount", align: "right" },
    { field: "amount", headerName: "Amount", align: "right" },
  ];

  const loyaltyColumns = [
    { field: "date", headerName: "Date" },
    {
      field: "",
      headerName: "Narration",
      renderCell: ({ row }) => (
        <div className="whitespace-nowrap">
          {row?.earn == "" ? "Burn" : "Earn"} for transaction: {row?.narration}
        </div>
      ),
    },
    { field: "earn", headerName: "Earn", align: "right" },
    { field: "burn", headerName: "Burn", align: "right" },
  ];

  // Customer Ledger Columns
  const ledgerColumns = [
    {
      field: "transactionNo",
      headerName: "Transaction No",
      renderCell: ({ row }) => (
        <div className="font-medium text-blue-600 hover:text-blue-800 cursor-pointer">
          {row.transactionNo}
        </div>
      )
    },
    {
      field: "transactionType",
      headerName: "Transaction Type",
      renderCell: ({ row }) => (
        <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
          {row.transactionType}
        </span>
      )
    },
    {
      field: "customerName",
      headerName: "Customer Name",
      renderCell: ({ row }) => (
        <div className="font-medium">{row.customerName}</div>
      )
    },
    {
      field: "debit",
      headerName: "Debit",
      align: "right",
      renderCell: ({ row }) => (
        <div className={`font-semibold ${row.debit > 0 ? 'text-red-600' : 'text-gray-400'}`}>
          {currencySymbol} {roundUpTo2(row.debit)}
        </div>
      )
    },
    {
      field: "credit",
      headerName: "Credit",
      align: "right",
      renderCell: ({ row }) => (
        <div className={`font-semibold ${row.credit > 0 ? 'text-green-600' : 'text-gray-400'}`}>
          {currencySymbol} {roundUpTo2(row.credit)}
        </div>
      )
    },
    {
      field: "Balance",
      headerName: "Balance",
      align: "right",
      renderCell: ({ row }) => (
        <div className={`font-bold ${row.Balance < 0 ? 'text-red-600' : row.Balance > 0 ? 'text-green-600' : 'text-gray-700'}`}>
          {currencySymbol} {roundUpTo2(row.Balance)}
        </div>
      )
    },
    {
      field: "Narration",
      headerName: "Narration",
      renderCell: ({ row }) => (
        <div className="text-sm text-gray-600 max-w-[200px] truncate" title={row.Narration}>
          {row.Narration}
        </div>
      )
    }
  ];

  const tabs = [
    { name: "Overview", label: "Overview" },
    { name: "Transaction", label: "Transaction" },
    // { name: "CustomerLedger", label: "Customer Ledger" },
    { name: "audit", label: "Audit Trail" },
  ];

     const onViewEasyRewardzDashboard=async()=>{
        setLoading(true);
        let response = await getEasyRewardWorkflowWidget(registration.key,
            store.StoreCode,
            customerData.PhoneNo
            )
        if(response.Success){
            let url = response.Data.WidgetURL;
            window.open(url,"_blank");
            setLoading(false);
        }
        else{
            toast.error("Unable to open EasyRewardz dashboard");
            setLoading(false);
        }

    }

  const deleteCustomerData = async () => {
    try {
      setOpenDeleteConfirm(false);
      setLoading(true);
      const response = await deleteCustomer(customerData.key);
      if (response && response.code === "0") {
        toast.success("Customer deleted successfully");
      } else {
        toast.error("Failed to delete customer");
      }
    } catch (error) {
      console.error("Failed to delete customer", error);
      toast.error("Failed to delete customer");
    } finally {
      setTimeout(() => {
        handleOnDelete();
        setLoading(false);
      }, 3000);
    }
  };

  // Animation variants
  const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 }
  };

const customerHeader = () => {
  return (
 <div className="flex flex-wrap items-center gap-2">
      
      {/* Phone */}
      {customerData?.PhoneNo && (
        <a
          href={`tel:${customerData.PhoneNo}`}
          className="flex items-center gap-2 px-3 py-1.5 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors group"
          title="Click to call"
        >
          <div className="w-7 p-1.5 bg-blue-100 rounded-full text-blue-600 group-hover:text-blue-700 transition-colors">
            <Icon type={"phone"} />
          </div>
          <span className="font-medium text-gray-700">
            {customerData.PhoneNo}
          </span>
        </a>
      )}

      {/* Email */}
      {customerData?.EmailID && (
        <a
          href={`mailto:${customerData.EmailID}`}
          className="flex items-center gap-2 px-3 py-1.5 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors group"
          title="Click to email"
        >
          <div className="w-7 p-1.5 bg-blue-100 rounded-full text-blue-600 group-hover:text-blue-700 transition-colors">
            <Icon type={"email"} />
          </div>
          <span className="font-medium text-gray-700 truncate max-w-[180px]">
            {customerData.EmailID}
          </span>
        </a>
      )}

      {/* Total Spent */}
      {apiData?.dashboardHeaders?.searchResult?.total_spent !== 0 && (
        <div className="flex items-center gap-2 px-3 py-1.5 bg-gray-100 rounded-lg">
          <div className="w-7 h-7 p-1 bg-purple-100 rounded-full text-purple-600 flex items-center justify-center">
            {currencySymbol}
          </div>
          <span className="font-medium text-gray-700">
            {currencySymbol}{" "}
            {roundUpTo2(apiData?.dashboardHeaders?.searchResult?.total_spent)}
          </span>
        </div>
      )}

      {/* Transactions */}
      {apiData?.dashboardHeaders?.searchResult?.total_transactions !== 0 && (
        <div className="flex items-center gap-2 px-3 py-1.5 bg-gray-100 rounded-lg">
          <div className="w-7 p-1 bg-green-100 rounded-full text-green-600">
            <Icon type={"totalTransaction"} />
          </div>
          <span className="font-medium text-gray-700">
            {apiData?.dashboardHeaders?.searchResult?.total_transactions} trans
          </span>
        </div>
      )}

      {/* Outstanding */}
      {customerData?.OutStandingAmount !== 0 && (
        <div className="flex items-center gap-2 px-3 py-1.5 bg-gray-100 rounded-lg">
          <div className="w-7 p-1 bg-red-100 rounded-full text-red-600">
            <Icon type={"alert-circle"} />
          </div>
          <span className="font-medium text-gray-700">
            {currencySymbol}{" "}
            {roundUpTo2(customerData?.OutStandingAmount)} due
          </span>
        </div>
      )}

      {/* Wallet */}
      {customerData?.WalletBalance !== 0 && (
        <div className="flex items-center gap-2 px-3 py-1.5 bg-gray-100 rounded-lg">
          <div className="w-7 p-1 bg-indigo-100 rounded-full text-indigo-600">
            <Icon type={"wallet"} />
          </div>
          <span className="font-medium text-gray-700">
            {currencySymbol}{" "}
            {roundUpTo2(customerData?.WalletBalance)} wallet
          </span>
        </div>
      )}

      {/* Loyalty */}
      {hasValue(loyalty?.LoyaltyPoints) && (
        <div className="flex items-center gap-2 px-3 py-1.5 bg-gray-100 rounded-lg">
          <div className="w-7 p-1 bg-amber-100 rounded-full text-amber-600">
            <Icon type={"loyalty"} />
          </div>
          <span className="font-medium text-gray-700">
            <span className="mr-1">{loyalty.LoyaltyType}</span>
            {roundUpTo2(loyalty.LoyaltyPoints)} pts
          </span>
        </div>
      )}

      {/* Membership */}
      {customerData?.Membership?.Name && (
        <div className="flex items-center gap-2 px-3 py-1.5 bg-gray-100 rounded-lg">
          <div className="w-7 p-1 bg-amber-100 rounded-full text-amber-600">
            <Icon type={"membership"} />
          </div>
          <span className="font-medium text-gray-700">
            {customerData.Membership.Name}
          </span>
        </div>
      )}

      {/* Segment */}
      {customerData?.segment && (
        <span
          className={`flex items-center gap-2 px-3 py-1.5 rounded-lg ${
            SEGMENT_COLORS[customerData.segment] ||
            "bg-gray-100 text-gray-600 border-gray-200"
          }`}
        >
          {customerData.segment}
        </span>
      )}
    </div>
  );
};
  return (
    <>
      <ViewPage
        handleRemoveBtnClick={handleCancelClick}
        highLightFirstLetter={
            !isMobileView() ? (
   customerData?.FirstName?.[0]
  ) : null
        }
        name={` ${customerData?.FirstName} ${customerData?.LastName}`}
      description={
  !isMobileView() ? (
   customerHeader()
  ) : null
}
        iconButtons={[
          ...(!customerData?.IsDeleted && getVisibility("Customers","update") ? [{
            label: "Edit",
            onClick: () => handleEditClick(),
            icon: <Icon type="edit" />,
            tooltipWidth: "70px"
          }] : []),
          ...(!customerData?.IsDeleted && apiData?.transactions?.searchResult.length == 0 && getVisibility("Customers","delete") ? [{
            label: "Delete Customer",
            onClick: () => setOpenDeleteConfirm(true),
            icon: <Icon type="delete" />,
            tooltipWidth: "150px"
          }] : []),
        ]}
        tabs={
          <Tab
            tabs={tabs}
            activeTab={activeTab}
            onTabChange={setActiveTab}
            className="sticky top-0 z-10 bg-white"
          />
        }
      >
        {loading ? (
          <div className="flex justify-center items-center h-64">
            <Loading size="lg" />
          </div>
        ) : (
          <div className="p-4">
            {activeTab === "Overview" && (
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                {/* Left Side - Client Details */}

                {/* General Details */}
                {isMobileView() && customerHeader()}
                <div>
                  <DetailTable title="General Details" mt="mt-[10px]">
                      <DetailRow label="Name" value={`${customerData?.FirstName} ${customerData?.LastName}`} condition={isMobileView()}/>
                    <DetailRow label="Gender" value={customerData?.Gender} />
                    <DetailRow
                      label="Date Of Birth"
                      value={
                        `${customerData?.DOBNew?.Day || ''}${customerData?.DOBNew?.Month ? ` ${customerData?.DOBNew?.Month}` : ''
                          }${customerData?.DOBNew?.Year ? ` ${customerData.DOBNew.Year}` : ''
                          }`.trim()
                      }
                    />
                    <DetailRow
                      label="Anniversary"
                      value={
                        `${customerData?.AnniversaryNew?.Day || ''}${customerData?.AnniversaryNew?.Month ? ` ${customerData?.AnniversaryNew.Month}` : ''
                          }${customerData?.AnniversaryNew?.Year ? ` ${customerData?.AnniversaryNew.Year}` : ''
                          }`.trim()
                      }
                    />
                    <DetailRow label="Notes" value={customerData?.Note} />
                    <DetailRow label="Customer Code" value={customerData?.CustomerCode} />
                    {[1, 2, 3, 4, 5, 6].map(num => (
                      <DetailRow
                        label={customerCustomFieldData[`CustomField${num}Name`] || `Custom Field ${num}`}
                        value={customerData?.[`CustomField${num}`]}
                      />
                    ))}
                  </DetailTable>

                  {registration?.BusinessTypeID=="7" && <DetailTable title="Pet Details">
                    <div className="flex flex-col space-y-5">
 {customerData?.PetDetails?.length > 0 ? (
                      customerData.PetDetails.map((pet, index) => (
                        <DetailTable
                          title={pet?.Type}
                          mt=""
                        >
                            <DetailRow label="Name" value={pet?.PetName} />
                          <DetailRow label="Gender" value={pet?.Gender} />
                          <DetailRow label="Date Of Birth" value={pet?.Dob} />
                          <DetailRow label="Breed" value={pet?.Breed} />
                          <DetailRow label="Height" value={pet?.Height} />
                          <DetailRow label="Weight" value={pet?.Weight} />
                        </DetailTable>
                      ))
                    ) : (
                      <div>No pet found</div>
                    )}
                    </div>
                   
                  </DetailTable>}

                  <DetailTable title="Address">
                    {customerData?.Addresses?.length > 0 ? (
                      customerData.Addresses.map((address, index) => (
                        <DetailTable
                          key={index}
                          title={address?.AddressType || 'Address'}
                          mt="mt-[2px]"
                        >
                          <DetailRow label="Line Address 1" value={address?.Address1 || '-'} />
                          <DetailRow label="Line Address 2" value={address?.Address2 || '-'} />
                          <DetailRow label="City" value={address?.City || '-'} />
                          <DetailRow label="State" value={address?.State || '-'} />
                          <DetailRow label="Postal Code" value={address?.PostalCode || '-'} />
                        </DetailTable>
                      ))
                    ) : (
                      <div>No address found</div>
                    )}
                  </DetailTable>
                </div>

                {/* Right Side - Overview Data */}
                <div className="mt-[10px]">
                  {/* Top Products */}
                  <div
                    className="bg-white rounded-lg shadow-sm p-5 border border-gray-100 hover:shadow-md transition-all"
                  >
                    <div className="flex items-center justify-between mb-4">
                      <h3 className="font-semibold text-[16px] flex items-center gap-2">
                        Top Purchases
                      </h3>
                    </div>

                    {topFiveProductsRows.length > 0 ? (
                      <div className="space-y-4">
                        {topFiveProductsRows.map((product, index) => (
                          <div
                            key={product.id}
                            className={`flex items-start p-3 rounded-lg hover:bg-gray-50 transition-colors ${index !== topFiveProductsRows.length - 1 ? 'border-b border-gray-100' : ''}`}
                          >
                            <span className="text-sm bg-gray-100 px-2 py-1 rounded-lg mr-3 mt-1">
                              #{index + 1}
                            </span>
                            <div className="flex-1">
                              <h4 className="font-medium">{product.productName}</h4>
                              <div className="flex items-center mt-1  text-(--tab-gray)">
                                <span>Qty: {product.totalQty}</span>
                                <span className="mx-2">•</span>
                                <span>Sales: {product.totalSales}</span>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="flex justify-center items-center py-8 text-(--tab-gray)">
                        No purchases found
                      </div>
                    )}
                  </div>

                  {/* Recent Purchase */}
                  <div
                    className="bg-white rounded-lg shadow-sm p-5 border border-gray-100 hover:shadow-md transition-all mt-5"
                  >
                    <div className="flex items-center justify-between mb-4">
                      <h3 className="font-semibold text-[16px]  flex items-center gap-2">
                        Recent Purchase
                      </h3>
                    </div>

                    {apiData?.transactions?.searchResult[0] ? (
                      <div className="space-y-4">
                        {customerData.LastVisitedOn && (
                          <div className="flex items-center">
                            <span className=" bg-[#eff6ff] px-2 py-1 rounded-lg">
                              <span className=" text-(--tab-gray)">Last Visited:</span>
                              {customerData?.LastVisitedOn && (() => {
                                const daysDiff = Math.floor((new Date() - new Date(customerData.LastVisitedOn)) / (1000 * 60 * 60 * 24));
                                return daysDiff <= 30 ? (
                                  <span className="ml-2">
                                    {daysDiff === 0 ? 'today' : `${daysDiff} day${daysDiff !== 1 ? 's' : ''} ago `}
                                  </span>
                                ) : null;
                              })()}
                              {customerData?.LastVisitedOn
                                ? `( ${new Date(customerData.LastVisitedOn).toLocaleDateString('en-US', {
                                  day: 'numeric',
                                  month: 'short',
                                  year: 'numeric',
                                  hour: '2-digit',
                                  minute: '2-digit'
                                })} )`
                                : ''}
                            </span>
                          </div>
                        )}

                        <div className="space-y-3">
                          <div className="text-[#6E2D90] flex items-center space-x-2">
                            <span className="cursor-pointer" onClick={() => { setViewTransaction(!viewTransaction) }} >View Transaction </span><span className="w-5 cursor-pointer" onClick={() => { setViewTransaction(!viewTransaction) }}><Icon type={`${viewTransaction ? "uparrow" : "downarrow"}`} /></span>
                          </div>
                          {viewTransaction && (
                            <>
                              <div>
                                <span className="text-(--tab-gray)">Transaction No:</span>
                                <span className="ml-1 font-medium">{customerData.LastTransactionNo}</span>
                              </div>

                              {apiData?.transactions?.searchResult[0]?.LineItems.map((lineitem, index) => (
                                <div className="bg-gray-50 p-3 rounded-lg mt-2">
                                  <h4 className="font-medium">{lineitem.Product.Name}</h4>
                                  <div className="mt-1">
                                    <div className="grid grid-cols-2 gap-1">
                                      <div>
                                        <span className="text-(--tab-gray)">Qty:</span>
                                        <span className="ml-1 font-medium">{lineitem.Qty}</span>
                                      </div>
                                      <div>
                                        <span className="text-(--tab-gray)">Price:</span>
                                        <span className="ml-1 font-medium">{currencySymbol} {lineitem.RetailPrice}</span>
                                      </div>
                                      <div>
                                        <span className="text-(--tab-gray)">Amount:</span>
                                        <span className="ml-1 font-medium">{currencySymbol} {lineitem.Amount}</span>
                                      </div>
                                      <div>
                                        <span className="text-(--tab-gray)">Discount:</span>
                                        <span className="ml-1 font-medium">
                                          {lineitem?.DiscountAmount
                                            ? `${currencySymbol}${roundUpTo2(lineitem.DiscountAmount)} (${lineitem.DiscountPer}%)`
                                            : 'N/A'
                                          }
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className="flex justify-center items-center py-8 text-(--tab-gray)">
                        No recent purchases found
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}

            {activeTab === "Transaction" && (
              <div>
                <div className="sticky top-0 z-10 bg-white pb-4">
                  <Tab
                    showBorder={true}
                    tabs={[
                      { label: "Sales", name: "Sales" },
                      ...(walletRows.length > 0 ? [{ label: "Wallet", name: "Wallet" }] : []),
                      ...((registration?.EnableEasyRewardz || loyaltyRows.length > 0) ? [{ label: "Loyalty Ledger", name: "Loyalty Ledger" }] : []),
                      ...(packageRows.length > 0 ? [{ label: "Packages", name: "Packages" }] : [])
                    ]}
                    activeTab={transactionActiveTab}
                    onTabChange={setTransactionActiveTab}
                    mt={"mt-0"}
                  />
                </div>

                <div>
                  {transactionActiveTab === "Loyalty Ledger" && (
                    <div className="bg-white rounded-lg  overflow-hidden">
                      {!registration?.EnableEasyRewardz &&<CustomTable
                        columns={loyaltyColumns}
                        rows={loyaltyRows}
                        showTextOnRows={loyaltyRows.length > 0 ? "" : "No data found"}
                      />}
                      {registration.EnableEasyRewardz && <Button type="secondary" onClick={onViewEasyRewardzDashboard}>View EasyRewardz Dashboard</Button>}

                      
                    </div>
                  )}

                  {transactionActiveTab === "Wallet" && (
                    <div className="bg-white rounded-lg shadow-sm overflow-hidden">
                      <CustomTable
                        columns={walletColumns}
                        rows={walletRows}
                        showTextOnRows={walletRows.length > 0 ? "" : "No data found"}
                      />
                    </div>
                  )}

                  {transactionActiveTab === "Packages" && (
                    <div className="bg-white rounded-lg shadow-sm overflow-hidden">
                      <CustomTable
                        columns={packageColumns}
                        rows={packageRows}
                        showTextOnRows={packageRows.length > 0 ? "" : "No data found"}
                      />
                    </div>
                  )}

                  {transactionActiveTab === "Sales" && (
                    <div className="bg-white rounded-lg shadow-sm overflow-hidden">
                      <CustomTable
                        columns={transactionColumns}
                        rows={transactionRows}
                        showTextOnRows={transactionRows.length > 0 ? "" : "No data found"}
                      />
                    </div>
                  )}
                </div>
              </div>
            )}

            {activeTab === "CustomerLedger" && (
              <div className="space-y-6">
                {/* Filter Section */}
                {/* <div className="bg-white rounded-xl shadow-sm p-6 border border-gray-200">
                  <h3 className="text-lg font-semibold text-gray-800 mb-4">Filter Ledger</h3>
                  <div className="flex flex-col md:flex-row gap-4">
                    <div className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          From Date
                        </label>
                        <input
                          type="date"
                          value={fromDate ? fromDate.toISOString().split('T')[0] : ''}
                          onChange={(e) => setFromDate(e.target.value ? new Date(e.target.value) : null)}
                          className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          To Date
                        </label>
                        <input
                          type="date"
                          value={toDate ? toDate.toISOString().split('T')[0] : ''}
                          onChange={(e) => setToDate(e.target.value ? new Date(e.target.value) : null)}
                          className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
                        />
                      </div>
                    </div>
                    
                    <div className="flex items-end gap-3">
                      <button
                        onClick={handleLedgerFilter}
                        disabled={ledgerLoading}
                        className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2.5 rounded-lg font-medium flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed transition"
                      >
                        {ledgerLoading ? (
                          <>
                            <Loading size="sm" />
                            Loading...
                          </>
                        ) : (
                          <>
                            <Icon type="filter" className="w-5 h-5" />
                            Apply Filter
                          </>
                        )}
                      </button>
                      <button
                        onClick={handleResetFilter}
                        className="bg-gray-100 hover:bg-gray-200 text-gray-700 px-6 py-2.5 rounded-lg font-medium flex items-center gap-2 transition"
                      >
                        <Icon type="refresh" className="w-5 h-5" />
                        Reset
                      </button>
                    </div>
                  </div>
                </div> */}

                {/* Filter Section */}
                <div className="bg-white rounded-xl shadow-sm p-6 border border-gray-200">
                  <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
                    <div className="flex-1">
                      <h3 className="text-lg font-semibold text-gray-800 mb-4">Customer Ledger</h3>
                      <div className="flex flex-col sm:flex-row items-start sm:items-end gap-4">
                        <div className="flex-1">
                          <label className="block text-sm font-medium text-gray-700 mb-2">
                            From Date
                          </label>
                          <div className="flex gap-2">
                            <input
                              type="date"
                              value={fromDate ? fromDate.toISOString().split('T')[0] : ''}
                              onChange={(e) => setFromDate(e.target.value ? new Date(e.target.value) : null)}
                              className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
                            />
                            <button
                              onClick={handleLedgerFilter}
                              disabled={ledgerLoading}
                              className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2.5 rounded-lg font-medium flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed transition whitespace-nowrap h-[42.5px]"
                            >
                              {ledgerLoading ? (
                                <>
                                  <Loading size="sm" />
                                  Loading...
                                </>
                              ) : (
                                <>
                                  <Icon type="eye" className="w-5 h-5" />
                                  View
                                </>
                              )}
                            </button>
                          </div>
                        </div>

                        <div className="flex items-end gap-3 h-[42.5px]">
                          <button
                            onClick={downloadCSV}
                            disabled={customerLedgerData.length === 0}
                            className="bg-green-600 hover:bg-green-700 text-white px-5 py-2.5 rounded-lg font-medium flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed transition h-full"
                            title="Download CSV"
                          >
                            <Icon type="download" className="w-5 h-5" />
                            <span className="hidden sm:inline">Download CSV</span>
                            <span className="inline sm:hidden">CSV</span>
                          </button>
                          <button
                            onClick={downloadPDF}
                            disabled={customerLedgerData.length === 0}
                            className="bg-red-600 hover:bg-red-700 text-white px-5 py-2.5 rounded-lg font-medium flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed transition h-full"
                            title="Download PDF"
                          >
                            <Icon type="download" className="w-5 h-5" />
                            <span className="hidden sm:inline">Download PDF</span>
                            <span className="inline sm:hidden">PDF</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Download Buttons */}
                {/* <div className="flex flex-wrap gap-3">
                  <button
                    onClick={downloadCSV}
                    disabled={customerLedgerData.length === 0}
                    className="bg-green-600 hover:bg-green-700 text-white px-5 py-2.5 rounded-lg font-medium flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed transition"
                  >
                    <Icon type="download" className="w-5 h-5" />
                    Download CSV
                  </button>
                  <button
                    onClick={downloadPDF}
                    disabled={customerLedgerData.length === 0}
                    className="bg-red-600 hover:bg-red-700 text-white px-5 py-2.5 rounded-lg font-medium flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed transition"
                  >
                    <Icon type="download" className="w-5 h-5" />
                    Download PDF
                  </button>
                </div> */}

                {/* Summary Cards */}
                {customerLedgerData.length > 0 && (
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div className="bg-gradient-to-r from-red-50 to-red-100 border-2 border-red-200 rounded-xl p-6 shadow-sm">
                      <div className="flex items-center justify-between">
                        <div>
                          <p className="text-sm font-medium text-red-600">Total Debit</p>
                          <p className="text-2xl font-bold text-red-700 mt-1">
                            {currencySymbol} {roundUpTo2(customerLedgerData.reduce((sum, item) => sum + (item.debit || 0), 0))}
                          </p>
                        </div>
                        <div className="p-3 bg-red-200 rounded-full">
                          <Icon type="arrow-down" className="w-6 h-6 text-red-600" />
                        </div>
                      </div>
                    </div>

                    <div className="bg-gradient-to-r from-green-50 to-green-100 border-2 border-green-200 rounded-xl p-6 shadow-sm">
                      <div className="flex items-center justify-between">
                        <div>
                          <p className="text-sm font-medium text-green-600">Total Credit</p>
                          <p className="text-2xl font-bold text-green-700 mt-1">
                            {currencySymbol} {roundUpTo2(customerLedgerData.reduce((sum, item) => sum + (item.credit || 0), 0))}
                          </p>
                        </div>
                        <div className="p-3 bg-green-200 rounded-full">
                          <Icon type="arrow-up" className="w-6 h-6 text-green-600" />
                        </div>
                      </div>
                    </div>

                    <div className="bg-gradient-to-r from-blue-50 to-blue-100 border-2 border-blue-200 rounded-xl p-6 shadow-sm">
                      <div className="flex items-center justify-between">
                        <div>
                          <p className="text-sm font-medium text-blue-600">Net Balance</p>
                          <p className={`text-2xl font-bold mt-1 ${customerLedgerData.reduce((sum, item) => sum + ((item.debit || 0) - (item.credit || 0)), 0) < 0 ? 'text-red-700' : 'text-blue-700'}`}>
                            {currencySymbol} {roundUpTo2(customerLedgerData.reduce((sum, item) => sum + ((item.debit || 0) - (item.credit || 0)), 0))}
                          </p>
                        </div>
                        <div className="p-3 bg-blue-200 rounded-full">
                          <Icon type="balance" className="w-6 h-6 text-blue-600" />
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Table Section */}
                <div className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-200">
                  <div className="p-6 border-b border-gray-200 bg-gradient-to-r from-gray-50 to-white">
                    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                      <div>
                        <h3 className="text-xl font-bold text-gray-800">Customer Ledger</h3>
                        <p className="text-sm text-gray-600 mt-1">
                          Transaction history for {customerData?.FirstName} {customerData?.LastName}
                        </p>
                      </div>
                      <div className="text-sm font-medium px-4 py-2 bg-blue-50 text-blue-700 rounded-lg">
                        Total Records: <span className="font-bold">{customerLedgerData.length}</span>
                      </div>
                    </div>
                  </div>

                  {ledgerLoading ? (
                    <div className="flex flex-col justify-center items-center h-64">
                      <Loading size="lg" />
                      <p className="mt-4 text-gray-600 font-medium">Loading ledger data...</p>
                    </div>
                  ) : customerLedgerData.length > 0 ? (
                    <CustomTable
                      columns={ledgerColumns}
                      rows={customerLedgerData.map((item, index) => ({
                        id: index,
                        transactionNo: item.transactionNo || 'N/A',
                        transactionType: item.transactionType || 'N/A',
                        customerName: item.customerName || 'N/A',
                        debit: item.debit || 0,
                        credit: item.credit || 0,
                        Balance: item.Balance || 0,
                        Narration: item.Narration || 'No narration'
                      }))}
                      className="min-h-[500px]"
                      showTextOnRows=""
                    />
                  ) : (
                    <div className="flex flex-col justify-center items-center h-96 text-center p-8">
                      <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mb-6">
                        <Icon type="file-text" className="w-12 h-12 text-gray-400" />
                      </div>
                      <h4 className="text-xl font-semibold text-gray-700 mb-2">No Ledger Data Found</h4>
                      <p className="text-gray-500 max-w-md">
                        No transaction records available for the selected date range.
                        Try adjusting your filters or check back later for updates.
                      </p>
                      <button
                        onClick={handleResetFilter}
                        className="mt-6 px-6 py-3 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition"
                      >
                        Reset Filters
                      </button>
                    </div>
                  )}
                </div>
              </div>
            )}

            {activeTab === "audit" && (
              <AuditTrail data={auditTrails} loading={AuditTrailLoading} />
            )}
          </div>
        )}
      </ViewPage>

      {openDeleteConfirm && (
        <ConfirmBox
          title={
            <>
              Are you sure you want to delete{" "}
              <span className="text-red-700">{customerData?.FirstName}</span>?
            </>
          }
          text="This action cannot be undone."
          onConfirm={deleteCustomerData}
          onCancel={() => setOpenDeleteConfirm(false)}
        />
      )}
    </>
  );
};

export default CustomerDetail;